import { development, staging, local, prod, uk } from "./env";
export default (() => {

    switch (process.env.REACT_APP_ENV) {
        case "dev":
        case "dev":
        case "development":
            return development;

        case "local":
        case "local ":
            return local;

        case "stag":
        case "stag ":
        case "staging":
            return staging;

        case "prod":
        case "prod ":
        case "production":
            return prod;

        case "uk":
        case "uk ":
        case "uk":
            return uk;

        default:
            return development;
    }
})();
